<template>
	<div>
		<nav aria-label="breadcrumb">
			<ol class="breadcrumb">
				<li class="breadcrumb-item" @click="$router.push('/accountancy')">Contabilidad</li>
				<li class="breadcrumb-item active" aria-current="page">Reportes regulatorios</li>
			</ol>
		</nav>
		<div class="container-fluid">
			<div class="row justify-content-md-center" style="margin-top:20px;">
				<div class="col-md-12">
					<vs-card>
						<template slot="header">
							<div class="row p-3 align-items-center border-bottom">
								<div class="col-4">
									<h1 class="text-info"><strong>R27</strong> / 2702</h1>
								</div>
								<div class="col-8 float-right">
									<nav>
										<div class="nav nav-tabs" id="nav-tab" role="tablist">
											<button class="nav-link active" id="nav-form-tab" data-bs-toggle="tab"
												data-bs-target="#nav-form" type="button" role="tab"
												aria-controls="nav-form" aria-selected="true">Formulario</button>
											<button class="nav-link" id="nav-envio-tab" data-bs-toggle="tab"
												data-bs-target="#nav-envio" type="button" role="tab"
												aria-controls="nav-envio" aria-selected="false">Envio</button>
											<button class="nav-link" id="nav-follow-tab" data-bs-toggle="tab"
												data-bs-target="#nav-follow" type="button" role="tab"
												aria-controls="nav-follow" aria-selected="false">Seguimiento</button>
										</div>
									</nav>
								</div>
							</div>
						</template>
						
							<div class="border-bottom">
								<div class="tab-content" id="nav-tabContent">
									<div class="tab-pane show active" id="nav-form" role="tabpanel"
										aria-labelledby="nav-form-tab">
										<h2 class="text-warning">Formulario</h2>
										<form class="form-group row" ref="formR27">

											<vs-divider>
												<h5><strong>Informacion solicitada</strong></h5>
											</vs-divider>


											<vs-divider>
												<h6>II.SECCIÓN: Identificacion de la reclamacion</h6>
											</vs-divider>

											<div class="form-group col-4">
												<label for="folioReclamacion">folioReclamacion:</label>
												<vs-input type="number" name="" class="w-full"
													:placeholder="form.informacionSolicitada.identificacionReclamacion.estatusReclamacion==101?this.form.auto:this.form.nonauto"
													v-model.lazy="form.informacionSolicitada.identificacionReclamacion.folioReclamacion"
													:readonly="form.informacionSolicitada.identificacionReclamacion.estatusReclamacion==101"/>
											</div>
											<div class="form-group col-4">
												<label>estatusReclamacion:</label>
												<vs-select class="w-full"
													v-model.lazy="form.informacionSolicitada.identificacionReclamacion.estatusReclamacion">
													<vs-select-item value="101" text="101 - Pendiente"  selected/>
													<vs-select-item value="102" text="102 - Concluida" />
													<vs-select-item value="103" text="103 - Reaperturapendiente" />
													<vs-select-item value="104" text="104 - Reapertura concluida" />
												</vs-select>
											</div>
											<div class="form-group col-4">
												<label class="vs-input--label">fechaActualizacionEstatus:</label>
												<datepicker placeholder="fechaActualizacionEstatus" :language="lang_es"
													v-model.lazy="form.informacionSolicitada.identificacionReclamacion.fechaActualizacionEstatus"
													format="yyyyMMdd" />
											</div>

											<div v-if="form.informacionSolicitada.identificacionReclamacion.estatusReclamacion==101"
												class="col-12 p-0 row m-0">
												<vs-divider>
													<h6>III.SECCIÓN: Identificador del cliente</h6>
												</vs-divider>

												<div class="form-group col-3">
													<label class="bg-info text-white">Busqueda cliente:</label>
													<!-- <input type="text" name="" class="w-full" placeholder=""> -->
													<input-search :txtNotFound="'Sin resultados con ese nombre...'"
														@on-item-selected="itemSelected($event)" :target-field="'name'"
														:Search="'search'" :filter-by-search="true"
														:show-new-botton="false"
														:api-source="'/api/app-http-services/services/sitiapi/users'"
														:model="form.search"></input-search>
												</div>
												<div class="form-group col-3">
													<label>tipoCliente:</label>
													<vs-select class="w-full"
														v-model.lazy="form.informacionSolicitada.identificadorCliente.tipoCliente">
														<vs-select-item value="1" text="1 - Inversionista" selected/>
														<vs-select-item value="2" text="2 - Solicitante"/>
													</vs-select>
												</div>
												<div class="form-group col-3">
													<label for="identificadorCliente">identificadorCliente:</label>
													<vs-input type="text" name="" class="w-full"
														:placeholder="this.form.auto"
														v-model.lazy="form.informacionSolicitada.identificadorCliente.identificadorCliente"
														readonly/>
												</div>
												<div class="form-group col-3">
													<label
														for="identificadorFinanciamiento">identificadorFinanciamiento:</label>
													<vs-input type="text" name="" class="w-full"
														:placeholder="this.form.optional"
														v-model.lazy="form.informacionSolicitada.identificadorCliente.identificadorFinanciamiento"/>
												</div>
											</div>

											<div v-if="form.informacionSolicitada.identificacionReclamacion.estatusReclamacion==101 || form.informacionSolicitada.identificacionReclamacion.estatusReclamacion==103"
												class="col-12 p-0 row m-0">
												<vs-divider>
													<h6>IV.SECCIÓN: Detalle de la reclamacion</h6>
												</vs-divider>

												<div class="form-group col-4">
													<label class="vs-input--label">fechaReclamacion:</label>
													<datepicker placeholder="fechaReclamacion" :language="lang_es"
														v-model.lazy="form.informacionSolicitada.detalleReclamacion.fechaReclamacion"
														format="yyyy-MM-dd" />
												</div>
												<div class="form-group col-4">
													<label>canalRecepcionReclamacion:</label>
													<vs-select class="w-full"
														v-model.lazy="form.informacionSolicitada.detalleReclamacion.canalRecepcionReclamacion">
														<vs-select-item value="201" text="201 - Página web"/>
														<vs-select-item value="202" text="202 - Teléfono fijo"/>
														<vs-select-item value="203" text="203 - Teléfono celula"/>
														<vs-select-item value="204" text="204 - Personal"/>
														<vs-select-item value="205" text="205 - Correo electrónico" selected/>
														<vs-select-item value="206" text="206 - CONDUSEF"/>
													</vs-select>
												</div>
												<div class="form-group col-4"
													v-if="form.informacionSolicitada.identificacionReclamacion.estatusReclamacion==101">
													<label>tipoReclamacion:</label>
													<vs-select class="w-full"
														v-model.lazy="form.informacionSolicitada.detalleReclamacion.tipoReclamacion">
														<vs-select-item value="301" text="301 - Evento único"/>
														<vs-select-item value="302" text="302 - Evento múltiple"/>
													</vs-select>
												</div>
												<div class="form-group col-4"
													v-if="form.informacionSolicitada.identificacionReclamacion.estatusReclamacion==101">
													<label>motivoReclamacion:</label>
													<vs-select class="w-full"
														v-model.lazy="form.informacionSolicitada.detalleReclamacion.motivoReclamacion">
														<vs-select-item value="401" text="401 - Producto no reconocido"/>
														<vs-select-item value="402" text="402 - Error operativo de la Institución"/>
														<vs-select-item value="403" text="403 - Error operativo del cliente"/>
														<vs-select-item value="404" text="404 - Suplantación o robo de identidad"/>
														<vs-select-item value="499" text="499 - Por definir" selected/>
													</vs-select>
												</div>
												<div class="form-group col-8">
													<label for="descripcionReclamacion">descripcionReclamacion:</label>
													<vs-textarea type="text" name="" class="w-full" placeholder=""
														v-model.lazy="form.informacionSolicitada.detalleReclamacion.descripcionReclamacion"/>
												</div>
											</div>

											<div v-if="form.informacionSolicitada.identificacionReclamacion.estatusReclamacion==101 && form.informacionSolicitada.detalleReclamacion.tipoReclamacion==301"
												class="col-12 p-0 row m-0">
												<vs-divider>
													<h6>V.SECCIÓN: Detalle del evento que origina la reclamacion</h6>
												</vs-divider>

												<div class="form-group col-3">
													<label class="vs-input--label">fechaEvento:</label>
													<datepicker placeholder="fechaEvento" :language="lang_es"
														v-model.lazy="form.informacionSolicitada.detalleEventoOriginaReclamacion.fechaEvento"
														format="yyyyMMdd" />
												</div>
												<div class="form-group col-3">
													<label>objetoEvento:</label>
													<vs-select class="w-full" v-model.lazy="form.informacionSolicitada.detalleEventoOriginaReclamacion.objetoEvento">
														<vs-select-item value="501" text="501 - Depósito no acreditado"/>
														<vs-select-item value="502" text="502 - Pago no acreditado"/>
														<vs-select-item value="503" text="503 - Error en la cantidad de dinerorecibido"/>
														<vs-select-item value="504" text="504 - Error en la cantidad de dinerotransferida"/>
														<vs-select-item value="505" text="505 - Cobro de comisión o comisiones noreconocidas"/>
														<vs-select-item value="506" text="505 - Cobro de intereses no reconocidos"/>
														<vs-select-item value="507" text="507 - Devolución no aplicada"/>
														<vs-select-item value="599" text="599 - Por definir"/>
													</vs-select>
												</div>
												<div class="form-group col-3">
													<label>canalOperacion:</label>
													<vs-select class="w-full"
														v-model.lazy="form.informacionSolicitada.detalleEventoOriginaReclamacion.canalOperacion">
														<vs-select-item value="601" text="601 - Aplicación móvil"/>
														<vs-select-item value="602" text="602 - Operaciones por internet:"/>
														<vs-select-item value="603" text="603 - Movimientos generados por laInstitución"/>
														<vs-select-item value="699" text="699 - Por definir" selected/>
													</vs-select>
												</div>
												<div class="form-group col-3">
													<label
														for="importeValorizadoMonedaNacional">importeValorizadoMonedaNacional:</label>
													<vs-input type="number" name="" class="w-full" placeholder=""
														v-model.lazy="form.informacionSolicitada.detalleEventoOriginaReclamacion.importeValorizadoMonedaNacional"/>
												</div>
											</div>

											<div v-if="form.informacionSolicitada.identificacionReclamacion.estatusReclamacion==101 && form.informacionSolicitada.detalleReclamacion.tipoReclamacion==302"
												class="col-12 p-0 row m-0">
												<vs-divider>
													<h6>V.SECCIÓN: Eventos subsecuentes / Detalle del evento que origina
														la
														reclamacion</h6>
													<vs-button size="normal" class="btn-block" @click="addEvent">
														Agregar</vs-button>
												</vs-divider>
												<eventos-subsecuentes
													v-for="(eventoSubsecuente,index) in form.informacionSolicitada.eventosSubsecuentes"
													v-bind:key="index" :eventoSubsecuente="eventoSubsecuente"
													@update="eventoSubsecuente = $event;"
													@remove="form.informacionSolicitada.eventosSubsecuentes.splice(form.informacionSolicitada.eventosSubsecuentes.indexOf($event), 1);">
												</eventos-subsecuentes>
											</div>

											<div v-if="form.informacionSolicitada.identificacionReclamacion.estatusReclamacion==102||form.informacionSolicitada.identificacionReclamacion.estatusReclamacion==104"
												class="col-12 p-0 row m-0">
												<vs-divider>
													<h6>VI.SECCIÓN: Detalle de la resolucion</h6>
												</vs-divider>

												<div class="form-group col-4">
													<label class="vs-input--label">fechaResolucion:</label>
													<datepicker placeholder="fechaResolucion" :language="lang_es"
														v-model.lazy="form.informacionSolicitada.detalleResolucion.fechaResolucion"
														format="yyyyMMdd" />
												</div>
												<div class="form-group col-4">
													<label>sentidoResolucion:</label>
													<vs-select class="w-full"
														v-model.lazy="form.informacionSolicitada.detalleResolucion.sentidoResolucion">
														<vs-select-item value="701" text="701 - Cliente desistió" selected/>
														<vs-select-item value="702" text="702 - Falta documentación del cliente"/>
														<vs-select-item value="703" text="703 - Plazo vencido al cliente"/>
														<vs-select-item value="704" text="704 - Reclamación reportada en más de unaocasión"/>
														<vs-select-item value="705" text="705 - Evidencia a favor de la Institución"/>
														<vs-select-item value="706" text="706 - Por normativa"/>
														<vs-select-item value="707" text="707 - Evidencia a favor del cliente"/>
														<vs-select-item value="708" text="708 - Plazo vencido a la Institución"/>
														<vs-select-item value="709" text="709 - Por política interna"/>
													</vs-select>
												</div>
												<div class="form-group col-4"
													v-if="form.informacionSolicitada.detalleResolucion.sentidoResolucion>705">
													<label
														for="importeAbonadoCuentaCliente">importeAbonadoCuentaCliente:</label>
													<vs-input type="number" name="" class="w-full" placeholder=""
														v-model.lazy="form.informacionSolicitada.detalleResolucion.importeAbonadoCuentaCliente"/>
												</div>
												<div class="form-group col-4"
													v-if="form.informacionSolicitada.detalleResolucion.sentidoResolucion>705">
													<label class="vs-input--label">fechaAbonoCuentaCliente:</label>
													<datepicker placeholder="fechaAbonoCuentaCliente"
														:language="lang_es"
														v-model.lazy="form.informacionSolicitada.detalleResolucion.fechaAbonoCuentaCliente"
														format="yyyyMMdd" />
												</div>
												<div class="form-group col-4">
													<label
														for="identificadorCuentaFideicomisoInstitucion">id.CuentaFideicomisoInstitucion:</label>
													<vs-input type="text" name="" class="w-full"
														:placeholder="this.form.auto"
														v-model.lazy="form.informacionSolicitada.detalleResolucion.identificadorCuentaFideicomisoInstitucion"/>
												</div>
												<div class="form-group col-4">
													<label for="importeRecuperado">importeRecuperado:</label>
													<vs-input type="number" name="" class="w-full" placeholder=""
														v-model.lazy="form.informacionSolicitada.detalleResolucion.importeRecuperado"/>
												</div>
												<div class="form-group col-4">
													<label class="vs-input--label">fechaRecuperacionRecursos:</label>
													<datepicker placeholder="fechaRecuperacionRecursos"
														:language="lang_es"
														v-model.lazy="form.informacionSolicitada.detalleResolucion.fechaRecuperacionRecursos"
														format="yyyyMMdd" />
												</div>
												<div class="form-group col-4">
													<label
														for="identificadorCuentaRecibeImporteRecuperado">id.CuentaRecibeImporteRecuperado:</label>
													<vs-input type="text" name="" class="w-full" placeholder=""
														v-model.lazy="form.informacionSolicitada.detalleResolucion.identificadorCuentaRecibeImporteRecuperado"/>
												</div>
												<div class="form-group col-4"
													v-if="form.informacionSolicitada.detalleReclamacion.tipoReclamacion==301">
													<label for="quebrantoInstitucion">quebrantoInstitucion:</label>
													<vs-input type="number" name="" class="w-full" placeholder=""
														v-model.lazy="form.informacionSolicitada.detalleResolucion.quebrantoInstitucion"/>
												</div>
											</div>
											<div class="form-group col-12">
												<vs-button color="success" @click="sendForm">Guardar</vs-button>
											</div>
										</form>
									</div>
									<div class="tab-pane" id="nav-envio" role="tabpanel"
										aria-labelledby="nav-envio-tab">
										<h2 class="">Envio periodo:</h2><br>
										<form class="border-bottom form-group row">
											<div class="form-group col-4">
												<label class="vs-input--label">inicioPeriodo:</label>
												<datepicker placeholder="inicioPeriodo" :language="lang_es"
													v-model.lazy="envio.inicioPeriodo" format="yyyy-MM-dd"
													value-type='format' />
											</div>
											<div class="form-group col-4">
												<label class="vs-input--label">finPeriodo:</label>
												<datepicker placeholder="finPeriodo" :language="lang_es"
													v-model.lazy="envio.finPeriodo" format="yyyy-MM-dd"
													value-type='format' />
											</div>
											<div class="form-group col-4">
												<label class="vs-input--label">Cargar Periodo:</label><br>
												<vs-button @click="getPeriod">Cargar</vs-button>
											</div>
										</form>
										<div class="row">
											<table class="table table-striped">
												<caption aria-hidden="true" v-if="false">Reportes regulatorios consultados al periodo establecido</caption>
												<thead>
													<tr>
														<th>Id</th>
														<th>Estatus</th>
														<th>Fecha de actualizacion</th>
														<th>Tipo cliente</th>
														<th>Identificador de cliente</th>
														<th>Identificador de financiamiento</th>
														<th>Action</th>
													</tr>
												</thead>
												<tbody>
													<tr v-for="(row,i) in this.complaints" v-bind:key="i">
														<td>
															<vs-button @click="detailPeriod(row.id)">
																#{{row.id}}
															</vs-button>
														</td>
														<td>{{row.estatusReclamacion.status}}</td>
														<td>{{row.fecha_estatus}}</td>
														<td>{{row.user_type==1?'Inversionista':row.user_type==2?'Solicitante':'Unexpected! o.O #Error'}}
														</td>
														<td>#{{row.user_id}}</td>
														<td>#{{row.project_id==null?'Sin proyecto asociado.':row.project_id}}
														</td>
														<td>
															<vs-button @click="deleteReport(row)" color='danger'
																size='small'>
																<feather-icon icon="TrashIcon"
																	svgClasses="w-5 h-5 hover:text-danger stroke-current cursor-pointer" />
															</vs-button>
														</td>
													</tr>
												</tbody>
											</table>
										</div>
										<div class="row">
											<div class="col-12 my-5">
												<h4 class="mr-10">Tipo de envio: </h4>
												<div class="form-check form-check-inline mr-5">
													<label class="form-check-label">
														<vs-input class="form-check-input" type="radio" name='radioSubmitType' v-model="submitType" value="envio"/> envio
													</label>
												</div>
												<div class="form-check form-check-inline mr-5">
													<label class="form-check-label">
														<vs-input class="form-check-input" type="radio" name='radioSubmitType' v-model="submitType" value="envio-vacio"/> envio-vacio
													</label>
												</div>
												<div class="form-check form-check-inline mr-5">
													<label class="form-check-label">
														<vs-input class="form-check-input" type="radio" name='radioSubmitType' v-model="submitType" value="correccion"/> correccion
													</label>
												</div>
											</div>
											<div class="col-12 my-5" v-if="submitType=='correccion'">
												<div class="form-group">
												  <label for="folio">Folio:</label>
												  <vs-input type="text" class="w-full" name="folio" id="folio" aria-describedby="folio" placeholder="" v-model="folio"/>
												</div>
											</div>
										</div>
										<form class="border-bottom form-group row">
											<div class="form-group col-4">
												<vs-button @click="sendPeriod" color='success'>
													ENVIAR
												</vs-button>
											</div>
										</form>
										<div v-if="jsonResponseSitiapi!=null">
											<h3 class="">Respuesta:</h3><br>
											<div v-html="$sanitizeHtml(jsonResponseSitiapi)"></div>
										</div>
									</div>
									<div class="tab-pane" id="nav-follow" role="tabpanel"
										aria-labelledby="nav-follow-tab">
										<seguimiento :folioProp='folio'></seguimiento>
									</div>
								</div>
							</div>
					</vs-card>
				</div>
			</div>
		</div>
	</div>
</template>

<script lang="js">
	import {
		es
	} from "vuejs-datepicker/dist/locale";
	import Datepicker from "vuejs-datepicker";
	import inputSearch from '@components/ui/inputSearch.vue'
	import eventosSubsecuentes from '@views/admin/reportes-regulatorios/R27EventosSubsecuentes'
	import seguimiento from '@views/admin/reportes-regulatorios/seguimiento'
	import syntaxHighlight from "@mixins/syntaxHighlightJSON";

	export default {
		name: 'reportes-regulatorios-r27',
		components: {
			seguimiento,
			Datepicker,
			'input-search': inputSearch,
			'eventos-subsecuentes': eventosSubsecuentes,
		},
		mixins: [syntaxHighlight],
		created() {
			this.addLibraries();
		},
		beforeMount() {
			let date = new Date();
			let firstDay = new Date(date.getFullYear(), date.getMonth(), 1);
			let lastDay = new Date(date.getFullYear(), date.getMonth() + 1, 0);
			this.form.identificadorReporte.inicioPeriodo = firstDay;
			this.form.identificadorReporte.finPeriodo = lastDay;
			this.envio.inicioPeriodo = firstDay;
			this.envio.finPeriodo = lastDay;
			this.form.informacionSolicitada.identificacionReclamacion.fechaActualizacionEstatus = date;
			this.form.informacionSolicitada.detalleReclamacion.fechaReclamacion = date;
			this.form.informacionSolicitada.detalleEventoOriginaReclamacion.fechaEvento = date;
			this.form.informacionSolicitada.detalleResolucion.fechaResolucion = date;
			this.form.informacionSolicitada.detalleResolucion.fechaAbonoCuentaCliente = date;
			this.form.informacionSolicitada.detalleResolucion.fechaRecuperacionRecursos = date;
		},
		mounted() {
			this.initInstance();
		},
		data() {
			return {
				form: {
					identificadorReporte: {
						inicioPeriodo: '',
						finPeriodo: '',
						// claveInstitucion: '065509', //QA
						claveInstitucion: '065028',
						reporte: '2702',
					},
					informacionSolicitada: {
						identificacionReclamacion: {
							folioReclamacion: '',
							estatusReclamacion: 101,
							fechaActualizacionEstatus: ''
						},
						identificadorCliente: {
							tipoCliente: 1,
							identificadorCliente: '',
							identificadorFinanciamiento: ''
						},
						detalleReclamacion: {
							fechaReclamacion: '',
							canalRecepcionReclamacion: 205,
							tipoReclamacion: 301,
							motivoReclamacion: 499,
							descripcionReclamacion: ""
						},
						detalleEventoOriginaReclamacion: {
							fechaEvento: '',
							objetoEvento: 599,
							canalOperacion: 699,
							importeValorizadoMonedaNacional: ''
						},
						eventosSubsecuentes: [],
						detalleResolucion: {
							fechaResolucion: '',
							sentidoResolucion: 702,
							importeAbonadoCuentaCliente: '',
							fechaAbonoCuentaCliente: '',
							identificadorCuentaFideicomisoInstitucion: '',
							importeRecuperado: '',
							fechaRecuperacionRecursos: '',
							identificadorCuentaRecibeImporteRecuperado: '',
							quebrantoInstitucion: ''
						}
					},
					auto: '<auto. gen.>',
					nonauto: '<non auto. gen.>',
					optional: 'Opcional',
					search: ''
				},
				lang_es: es,
				envio: {
					inicioPeriodo: '',
					finPeriodo: '',
				},
				folio: '',
				complaints: [],
				jsonResponseSitiapi: null,
				submitType: 'envio',
			}
		},
		methods: {
			itemSelected(item) {
				this.form.informacionSolicitada.identificadorCliente.identificadorCliente = item.id;
				this.form.informacionSolicitada.detalleResolucion.identificadorCuentaFideicomisoInstitucion = item.id;
			},
			addLibraries() {
				//TODO: Add css, js libraries here
			},
			initInstance() {
				const self = this;
				var triggerTabList = [].slice.call(document.querySelectorAll('#nav-tab button'));
				triggerTabList.forEach(function (triggerEl) {
					var tabTrigger = new bootstrap.Tab(triggerEl);
					triggerEl.addEventListener('click', function (event) {
						event.preventDefault();
						tabTrigger.show();
						$('#nav-tabContent .tab-pane').hide();
						$(tabTrigger._element.dataset.bsTarget).show();
					});
				});

				$('form :input').change(function (e) {
					if (e.target.value === "" || e.target.value === 0) {
						e.target.classList.add("bg-danger");
						e.target.classList.remove("bg-success-light");
					} else {
						e.target.classList.remove("bg-danger");
						e.target.classList.add("bg-success-light");
					}
				});
			},
			addEvent() {
				this.form.informacionSolicitada.eventosSubsecuentes.push({
					...this.form.informacionSolicitada.detalleEventoOriginaReclamacion
				});
			},
			async sendForm() {
				// console.log('sendForm');
				if (this.validateForm()) {
					let self = this;
					try {
						switch (parseInt(self.form.informacionSolicitada.identificacionReclamacion
							.estatusReclamacion)) {
							case 101:
							case 103:
								// console.log('estatusReclamacion', this.form.informacionSolicitada
								//	.identificacionReclamacion.estatusReclamacion);
								await axios.post('/api/sitiapi/r27/complaints', this.form.informacionSolicitada).then(
									response => {
										this.$refs.formR27.reset();
										swal("Done", 'Nuevo registro agregado correctamente.', "success");
										// console.log(response);
									});
								break;
							case 102:
							case 104:
								// console.log('estatusReclamacion', this.form.informacionSolicitada
								//	.identificacionReclamacion.estatusReclamacion);
								await axios.put(
									`/api/sitiapi/r27/complaints/${this.form.informacionSolicitada.identificacionReclamacion.folioReclamacion}`,
									this.form.informacionSolicitada).then(
									response => {
										this.$refs.formR27.reset();
										swal("Done", 'Registro actualizado correctamente.', "success");
										// console.log(response);
									});
								break;

							default:
								// console.log('default', 'estatusReclamacion', this.form.informacionSolicitada
								//	.identificacionReclamacion.estatusReclamacion);
								break;
						}
					} catch (error) {
						if (error.response.status === 400) {
							await swal("Formulario incompleto ó incorrecto", JSON.stringify(error.response.data),
								"warning")
						} else if (error.response.status === 404) {
							// await swal("Folio incorrecto", JSON.stringify(error.response.data),
							await swal("Error #404", 'Folio incorrecto',
								"warning")
						} else if (error.response.status === 500) {
							await swal("Error", JSON.stringify(error.response.data),
								"warning")
						}
					}
				}
			},
			validateForm() {
				//TODO: Do this to set filters
				return true;
			},
			async getEvents(complaint_id) {
				return await axios.get(
						`/api/sitiapi/r27/complaints/events/${complaint_id}`
					)
					.then(response => response.data);
			},
			async getPeriod() {
				this.$vs.loading();
				await axios.get(
						`/api/sitiapi/r27/complaints/period/${this.envio.inicioPeriodo.toISOString()}/${this.envio.finPeriodo.toISOString()}`
					)
					.then(response => {
						let payload = response.data;
						this.complaints = [];
						for (let key in payload) {
							let estatusReclamacion = {};
							if (payload[key].fecha_estatus_reapertura_concluida !== null) {
								estatusReclamacion = {
									'status': 'reapertura_concluida',
									'code': 104,
									'date': payload[key].fecha_estatus_reapertura_concluida
								};
							} else if (payload[key].fecha_estatus_reapertura_pendiente !== null) {
								estatusReclamacion = {
									'status': 'reapertura_pendiente',
									'code': 103,
									'date': payload[key].fecha_estatus_reapertura_pendiente
								};
							} else if (payload[key].fecha_estatus_concluida !== null) {
								estatusReclamacion = {
									'status': 'concluida',
									'code': 102,
									'date': payload[key].fecha_estatus_concluida
								};
							} else if (payload[key].fecha_estatus_pendiente !== null) {
								estatusReclamacion = {
									'status': 'pendiente',
									'code': 101,
									'date': payload[key].fecha_estatus_pendiente
								};
							}
							this.complaints.push({
								...payload[key],
								...{
									'estatusReclamacion': estatusReclamacion
								}
							});
						}
						// console.log(this.complaints);
						return this.complaints;
					});
				this.$vs.loading.close();
			},
			detailPeriod(id) {
				let detail = this.complaints.find(row => row.id == id);
				swal({title:`Detalle #${id}:`, text:`${JSON.stringify(detail, undefined, 4).replaceAll('"', ' ')}`});
			},
			async sendPeriod() {
				// this.$vs.loading();
				let json_sitiapi = {
					identificadorReporte: {
						inicioPeriodo: this.envio.inicioPeriodo.toISOString().split('T')[0].replaceAll('-',
							''),
						finPeriodo: this.envio.finPeriodo.toISOString().split('T')[0].replaceAll('-', ''),
						// claveInstitucion: '065509', //QA
						claveInstitucion: '065028',
						reporte: '2702',
					},
					informacionSolicitada: []
				};
				if (this.submitType=='envio-vacio') {
					this.sendJson({
						identificadorReporte: {
							...json_sitiapi.identificadorReporte
						}
					});
				} else {
					for (const ix in this.complaints) {
						// console.log('ix', ix);
						let complaint = this.complaints[ix];
						let informacionSolicitada = null;
						let objEvents = null;
						if (complaint.tipo_reclamacion == '301') {
							let events = await this.getEvents(complaint.id);
							// console.log('301', 'events', events);
							event = events[0];
							objEvents = {
								detalleEventoOriginaReclamacion: {
									fechaEvento: this.formatFechaReclamacion(event.fecha_evento),
									objetoEvento: event.objeto_evento,
									canalOperacion: event.canal_operacion,
									importeValorizadoMonedaNacional: event.importe_valorizado_moneda_nacional
								}
							};
						} else if (complaint.tipo_reclamacion == '302') {
							objEvents = {
								eventosSubsecuentes: []
							};
							let events = await this.getEvents(complaint.id);
							// console.log('302', 'events', events);
							for (const itEvent of events) {
								objEvents.eventosSubsecuentes.push({
									detalleEventoOriginaReclamacion: {
										fechaEvento: this.formatFechaReclamacion(itEvent.fecha_evento),
										objetoEvento: itEvent.objeto_evento,
										canalOperacion: itEvent.canal_operacion,
										importeValorizadoMonedaNacional: itEvent
											.importe_valorizado_moneda_nacional
									}
								});
							}
						}
						// console.log('objEvents', objEvents);
						// console.log('complaint.estatusReclamacion.status', complaint.estatusReclamacion.code);
						switch (complaint.estatusReclamacion.code) {
							case 101:
								informacionSolicitada = {
									identificacionReclamacion: {
										folioReclamacion: this.formatFolioReclamacion(complaint.id),
										estatusReclamacion: complaint.estatusReclamacion.code,
										fechaActualizacionEstatus: this.formatFechaReclamacion(complaint
											.estatusReclamacion.date)
									},
									identificadorCliente: {
										tipoCliente: complaint.user_type,
										identificadorCliente: this.formatIdentificador(complaint.user_id),
										identificadorFinanciamiento: complaint.project_id,
									},
									detalleReclamacion: {
										fechaReclamacion: this.formatFechaReclamacion(complaint.fecha_reclamacion),
										canalRecepcionReclamacion: complaint.canal_recepcion_reclamacion,
										tipoReclamacion: complaint.tipo_reclamacion,
										motivoReclamacion: complaint.motivo_reclamacion,
										descripcionReclamacion: complaint.descripcion_reclamacion
									},
									...objEvents,
								};
								break;
							case 102:
								informacionSolicitada = {
									identificacionReclamacion: {
										folioReclamacion: this.formatFolioReclamacion(complaint.id),
										estatusReclamacion: complaint.estatusReclamacion.code,
										fechaActualizacionEstatus: this.formatFechaReclamacion(complaint
											.estatusReclamacion.date)
									},
									detalleResolucion: {
										fechaResolucion: this.formatFechaReclamacion(complaint.fecha_resolucion),
										sentidoResolucion: complaint.sentido_resolucion,
										importeAbonadoCuentaCliente: complaint.importe_abonado_cuenta_cliente,
										fechaAbonoCuentaCliente: this.formatFechaReclamacion(complaint
											.fecha_abono_cuenta_cliente),
										identificadorCuentaFideicomisoInstitucion: complaint
											.identificador_cuenta_fideicomiso_institucion,
										importeRecuperado: complaint.importe_recuperado,
										fechaRecuperacionRecursos: this.formatFechaReclamacion(complaint
											.fecha_recuperacion_recursos),
										identificadorCuentaRecibeImporteRecuperado: complaint
											.identificador_cuenta_recibe_importe_recuperado,
										quebrantoInstitucion: complaint.quebranto_institucion
									}
								};
								break;
							case 103:
								informacionSolicitada = {
									identificacionReclamacion: {
										folioReclamacion: this.formatFolioReclamacion(complaint.id),
										estatusReclamacion: complaint.estatusReclamacion.code,
										fechaActualizacionEstatus: this.formatFechaReclamacion(complaint
											.estatusReclamacion.date)
									},
									detalleReclamacion: {
										fechaReclamacion: this.formatFechaReclamacion(complaint.fecha_reclamacion),
										canalRecepcionReclamacion: complaint.canal_recepcion_reclamacion,
										// tipoReclamacion: complaint.tipo_reclamacion,
										// motivoReclamacion: complaint.motivo_reclamacion,
										descripcionReclamacion: complaint.descripcion_reclamacion
									},
								};
								break;
							case 104:
								informacionSolicitada = {
									identificacionReclamacion: {
										folioReclamacion: this.formatFolioReclamacion(complaint.id),
										estatusReclamacion: complaint.estatusReclamacion.code,
										fechaActualizacionEstatus: complaint.estatusReclamacion.date
									},
									detalleResolucion: {
										fechaResolucion: this.formatFechaReclamacion(complaint.fecha_resolucion),
										sentidoResolucion: complaint.sentido_resolucion,
										importeAbonadoCuentaCliente: complaint.importe_abonado_cuenta_cliente,
										fechaAbonoCuentaCliente: this.formatFechaReclamacion(complaint
											.fecha_abono_cuenta_cliente),
										identificadorCuentaFideicomisoInstitucion: complaint
											.identificador_cuenta_fideicomiso_institucion,
										importeRecuperado: complaint.importe_recuperado,
										fechaRecuperacionRecursos: this.formatFechaReclamacion(complaint
											.fecha_recuperacion_recursos),
										identificadorCuentaRecibeImporteRecuperado: complaint
											.identificador_cuenta_recibe_importe_recuperado,
										quebrantoInstitucion: complaint.quebranto_institucion
									}
								};
								break;
						}
						// console.log('informacionSolicitada', informacionSolicitada);
						json_sitiapi.informacionSolicitada.push(informacionSolicitada);
					}
					// console.log('json_sitiapi', json_sitiapi);
					this.sendJson(json_sitiapi);
				}
				// this.$vs.loading.close();
			},
			async deleteReport(report) {
				if (confirm(`¿Esta seguro de eliminar el reporte #${report.id}?`)) {
					this.$vs.loading();
					try {
						await axios.delete(
							`/api/sitiapi/r27/complaints/${report.id}`);
						this.complaints.splice(this.complaints.indexOf(report), 1);
					} catch (e) {
						await swal("Alerta", JSON.stringify(e.response.data), 'warning');
					}
					this.$vs.loading.close();
				}
			},
			formatFolioReclamacion(folioReclamacion) {
				let fR = folioReclamacion.toString();
				if (fR.length < 8) {
					let fRFormat = fR;
					for (let i = fR.length; i < 8; i++) {
						fRFormat = '0' + fRFormat;
					}
					fR = fRFormat;
				}
				return fR;
			},
			formatIdentificador(identificador) {
				let id = identificador.toString();
				if (id.length < 7) {
					let idFormat = id;
					for (let i = id.length; i < 7; i++) {
						idFormat = '0' + idFormat;
					}
					id = idFormat;
				}
				return id;
			},
			formatFechaReclamacion(date) {
				return date.split(' ')[0].replaceAll('-', '');
			},
			async sendJson(json_sitiapi) {
				this.jsonResponseSitiapi = null;
				let url = '';
				switch (this.submitType) {
					case 'envio':
						url = `/api/sitiapi/IFC/R27/2702`;
						break;
					case 'correccion':
						url = `/api/sitiapi/IFC/R27/2702/correccion/${this.folio}`;
						break;
					case 'reenvio':
						url = `/api/sitiapi/IFC/R27/2702/reenvio/${this.folio}`;
						break;
					case 'envio-vacio':
						url = `/api/sitiapi/IFC/R27/2702/envio-vacio`;
						break;
				}
				await this.requestPost(url, json_sitiapi, async (jsonReponse) => {
					this.jsonResponseSitiapi = this.syntaxHighlight(JSON.stringify(jsonReponse, null, 4));
					if (typeof jsonReponse.folio !== 'undefined') {
						this.folio = jsonReponse.folio;
					}
					let jsonToStore = {
						'reportCategory': 'R27',
						'reportCode': '2702',
						'reportLabel': `${this.folio}`,
						'type': `${this.submitType}`,
						'jsonSent': json_sitiapi,
						'jsonReceived': jsonReponse ?? {}
					};
					let jsonResponsePersist = await this.requestPost('/api/sitiapi/regulatoryReports',
						jsonToStore, (jsonReponsePersistence) => {
							return jsonReponsePersistence;
						});
					return [jsonReponse, jsonResponsePersist];
				});
			},
			async requestPost(url, data, callback) {
				let rP = await axios.post(url, data)
					.then(response => response.data);
				callback(rP);
			},
		},
	}
</script>

<style scoped lang="scss">
</style>